import { default as en } from './en'
import { default as fr } from './fr'

export const messages = {
  en: {
    ...en
  },
  fr: {
    ...fr
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/translations/index.js